import HelpActionPomp from "./HelpActionPomp";
import Legenda from "./Legenda";
import { useState } from "react";
import PainelPomp from "./PainelPomp";
import { limpa, limpaLegenda, valid, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2 } from "./Aux.js";


const Pomp = (props) => {

    props.setComp('pomp');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar procura e/ou oferta por troço. Query demand and/or supply by stretch.');
    
    const [csv, setCsv] = useState('');
    var specs = {...props.specs};
    
    function poQuery(e) {
        e.preventDefault();
        limpaLegenda();
        let s = {...props.specs};
        let txtd = "Úteis";
        let tableName = "uteis";
        if (props.specs.dias === 'Todos'){
            tableName = 'todos';
            txtd = "Todos";
        }
        let nv = parseInt(props.specs.nv); 
        let shortv = props.varGlob.shortvar[nv]; 
        if (props.specs.crit === "Intervalo T") {
            shortv = shortv.replace("AB", " para Trindade");
            shortv = shortv.replace("BA", " de Trindade");
        }
        let nome = props.varGlob.nomevar[nv] + ' DESC ';// 
        if (props.specs.crit !== "Ranking"){ // TODO verificar
            nome = "stretchNumber" + ' ASC ';
        }
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2016 2017 2018 2019 2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2016, 2021, props.ling, 2021);
        if(anos.length < 1) {
            anos = ['2016', '2017', '2018', '2019', '2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')  
        };
        s.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if(meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i])-1]);
        }
        s.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let horas = props.specs.horas;
        if (horas === '') {
            horas = '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24';
        }
        horas = horas.split(" ");
        horas = limpa(horas, 1, 24, props.ling, 8);
        if( horas.length < 1) {
            horas = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            alert('Input errado para horas foi substituído. / Wrong input for hours was replaced.')
        };
        s.horas = horas.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        specs = s;
        let mensagem = "Coloridos os troços em função de " + shortv + "<br>";
        mensagem += "<br>Nos dias:      "  + txtd; 
        mensagem += "<br>Do(s) ano(s):      "  + anos; 
        mensagem += "<br>No(s) mes(es) de:     " + lmeses;
        mensagem += "<br>Na(s) hora(s):     " + horas;
        let filtro = anos + ";" + lmeses + ";" + horas + ";" + txtd + ";";
        const params = {
            "serv": "pomp",
            "anosp": anos,
            "mesesp": meses,
            "horasp": horas,
            "tableName": tableName,
            "v": nome
        };
        pompFetchAsync (
            "/bqmapsnode/?params="  + JSON.stringify(params), filtro
        );
    }

    async function pompFetchAsync (url, filtro) {
        let response = await fetch (url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados != null && resultados.length > 0) {
                console.log (resultados);
                let s = {...specs};
                s.res = resultados;
                props.setSpecs(s);
                pompSaveCsv(resultados, filtro);
                return resultados;
            } else {
                pompAlertaDados();
                return resultados;
            }
        } else {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    }

    function pompAlertaDados() {
        if (props.ling === 'pt') {
            alert ('Não há dados para o período especificado!  Só para Jan 2016 a Fev 2021 inc para todos os dias e para Nov 2016 a Fev 2021 para dias úteis.');
        } else {
            alert ('No data for the specified period! Only for Jan 2016 to Feb 2021, inc. (for all days) and for Nov 2016 to Feb 2021, inc. (for week days)')
        }
    }

    async function pompSaveCsv(resultados, filtro){
        setCsv('');
        let ponto = resultados[0];
        let campo = Object.keys(ponto);
        let lab, lba, pab, pba, p;
        let nv = parseInt(props.specs.nv); 
        let csvCont = "Anos;Meses;Horas;Dias; \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "Troço;A;B; \n";
        // identifica a variável pesquisada
        if (nv === 0) { csvCont = csvCont + "PAXAB\n"}
        else if (nv === 1) {csvCont = csvCont + "PaxBA\n";}
        else if (nv === 2) {csvCont = csvCont + "Pax\n";}
        else if (nv === 3) {csvCont = csvCont + "ETAB\n";}
        else if (nv === 4) {csvCont = csvCont + "ETBA\n";}
        else if (nv === 5) {csvCont = csvCont + "TTAB\n";}
        else if (nv === 6) {csvCont = csvCont + "TTBA\n";}
        else if (nv === 7) {csvCont = csvCont + "LugAB\n";}
        else if (nv === 8) {csvCont = csvCont + "LugBA\n";}
        else if (nv === 9) {csvCont = csvCont + "TOAB\n";}
        else if (nv === 10) {csvCont = csvCont + "TOBA\n";}
        else if (nv === 11) {csvCont = csvCont + "maxTO\n";}
        for (let i=0; i<82; i++){
            lab = parseInt(resultados[i][campo[8]])*216 + parseInt(resultados[i][campo[10]])*248;
            lba = parseInt(resultados[i][campo[9]])*216 + parseInt(resultados[i][campo[11]])*248;
            pab = parseInt(resultados[i][campo[5]]);
            pba = parseInt(resultados[i][campo[6]]); 
            p = pab + pba;
            csvCont = csvCont + resultados[i][campo[0]] + ";" + props.varGlob.stationA[resultados[i][campo[0]]-1] + ";";
            csvCont = csvCont + props.varGlob.stationB[resultados[i][campo[0]]-1] + ";";
            if (nv === 0) {csvCont = csvCont + pab + "\n";}
            else if (nv === 1) {csvCont = csvCont + pba + ";\n";}
            else if (nv === 2) {csvCont = csvCont + p + ";\n";}
            else if (nv === 3) {csvCont = csvCont + parseInt(resultados[i][campo[8]]) + ";\n";}
            else if (nv === 4) {csvCont = csvCont + parseInt(resultados[i][campo[9]]) + ";\n";}
            else if (nv === 5) {csvCont = csvCont + parseInt(resultados[i][campo[10]]) + ";\n";}
            else if (nv === 6) {csvCont = csvCont + parseInt(resultados[i][campo[11]]) + ";\n";}
            else if (nv === 7) {csvCont = csvCont + lab + ";\n";}
            else if (nv === 8) {csvCont = csvCont + lba + ";\n";}
            else if (nv === 9) {csvCont = csvCont + 100*pab/lab + ";\n";}
            else if (nv === 10) {csvCont = csvCont + 100*pba/lba + ";\n";}
            else if (nv === 11) {csvCont = csvCont + 100 * Math.max(pab/lab, pba/lba) + "\n";}
        }
        let response = await fetch ("/bqmapsnode/?fileToWrite="  + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
        setCsv(fileName);
    }
    
    
    /* useEffect(() => {
        document.getElementById("menu").style.marginLeft = '160px';
    }, [] ); */


    return ( 
        <div className="pomp">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpActionPomp
                        ling={props.ling} 
                        titPt={"Colorir estações em função de:"}
                        titUk={"To color stations according to supply and demand"}
                        helpPt={"https://docs.google.com/presentation/d/1zd4S2e61BQJ-YWqC8itNsNDbWGK7UN61dvh3YV9fxik/edit?usp=sharing"}
                        helpUk={"https://docs.google.com/presentation/d/1Ei54znAJMQYMDYha8rpGkqC3Us40c0l6dr9Zn7SyKLw/edit?usp=sharing"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={poQuery}
                        csv={csv}
                        download={download} />
                    <PainelPomp
                        ling={props.ling}
                        specs={props.specs}
                        setSpecs={props.setSpecs}
                        comp={props.comp}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob}  />
                    <Legenda />
                </div>
            </div>
        </div>
    );
}

export default Pomp;